import DialogResponsive from 'my-elements/DialogResponsive';

import CoursePageStudySessionCard from '../CoursePageStudySessionCard';
import StudySessionCheckoutConfirmation from './StudySessionCheckoutConfirmation';
import StudySessionCheckoutHeader from './StudySessionCheckoutHeader';
import StudySessionCheckoutPayment from './StudySessionCheckoutPayment';

import Box from '@mui/material/Box';

export default function StudySessionCheckout({
  activeStep,
  confirming,
  currentUser,
  noDialog,
  onChangeStep,
  onClose,
  onPaymentSuccess,
  open,
  pricingInfo,
  studySession,
  studySessionUser,
}) {
  // const invalidAmount = !!(purchaseIntent && purchaseIntent.amount !== parseInt((studySession.price * 100).toFixed()));

  return noDialog ? renderActiveStep() : (
      <DialogResponsive fullWidth onClose={confirming ? undefined : onClose} open={open}>
        <StudySessionCheckoutHeader
          activeStep={activeStep}
          loading={confirming}
          onChangeStep={onChangeStep}
          onClose={onClose}
        />
        {renderActiveStep()}
      </DialogResponsive>
    );

  function renderActiveStep() {
    switch (activeStep) {
      case 0:
        return (
          <>
            {noDialog && (
              <CoursePageStudySessionCard
                course={studySession.course}
                css={({ spacing }) => ({ marginBottom: spacing(4) })}
                smallCard
                studySession={studySession}
              />
            )}
            <Box
              sx={
                noDialog ? undefined : (
                  {
                    px: [2, 8],
                    py: 2,
                    backgroundColor: 'background.default',
                  }
                )
              }
            >
              <StudySessionCheckoutPayment
                currentUser={currentUser}
                loading={confirming}
                noDialog={noDialog}
                onClose={onClose}
                onPaymentSuccess={onPaymentSuccess}
                pricingInfo={pricingInfo}
                studySession={studySession}
                studySessionUser={studySessionUser}
              />
            </Box>
          </>
        );
      case 1:
        return (
          <div>
            <StudySessionCheckoutConfirmation noDialog={noDialog} onClose={onClose} studySession={studySession} />
          </div>
        );
    }
  }
}

// StudySessionCheckout.propTypes = {
//   noDialog: PropTypes.bool,
//   onClose: PropTypes.func.isRequired,
//   onPaymentSuccess: PropTypes.func.isRequired,
//   open: PropTypes.bool,
//   purchaseIntent: PropTypes.object,
//   studySession: PropTypes.object.isRequired,
// };
